import { wildResponseHandler } from "@wildidea/tools/utils/wildResponseHandler.js";

import {
  LoginInput,
  LoginResponse,
} from "../../../../src/auth/domain/model/Login.js";
import { API_PREFIX } from "../../../../src/auth/domain/model/version.js";

const JSON_RESPONSE_HEADERS = { Accept: "application/json" };
const JSON_REQUEST_HEADERS = { "Content-Type": "application/json" };

/**
 * This exists because the normal LoginServiceClient is browser-only and cannot run on Node.
 * It also performs the login refresh automatically rather than manually as this one does.
 */
export class LoginServiceClient {
  private baseUri: string;
  protected baseHeaders: Record<string, string> = JSON_RESPONSE_HEADERS;
  constructor({ baseUri }: { baseUri?: string }) {
    this.baseUri = baseUri || "";
  }

  async login(
    input: LoginInput,
  ): Promise<LoginResponse & { cookies: string[] }> {
    const promise = fetch(`${this.baseUri}${API_PREFIX}/login`, {
      method: "POST",
      headers: { ...this.baseHeaders, ...JSON_REQUEST_HEADERS },
      body: JSON.stringify(input),
    });
    const { expires } = await wildResponseHandler<LoginResponse>(
      promise,
      "login",
    );
    const cookies = (await promise).headers.getSetCookie();
    return { expires, cookies };
  }

  async refreshLogin(): Promise<LoginResponse & { cookies: string[] }> {
    const promise = fetch(`${this.baseUri}${API_PREFIX}/login/refresh`, {
      method: "POST",
      headers: { ...this.baseHeaders, ...JSON_REQUEST_HEADERS },
    });
    const { expires } = await wildResponseHandler<LoginResponse>(
      promise,
      "refreshLogin",
    );
    const cookies = (await promise).headers.getSetCookie();
    return { expires, cookies };
  }

  async logout(): Promise<void> {
    await wildResponseHandler(
      fetch(`${this.baseUri}${API_PREFIX}/logout`, {
        method: "POST",
        headers: this.baseHeaders,
      }),
      "logout",
    );
  }
}
